/* eslint-disable max-len */
const SortIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.46967 8.46967C2.17678 8.76256 2.17678 9.23744 2.46967 9.53033C2.76256 9.82322 3.23744 9.82322 3.53033 9.53033L2.46967 8.46967ZM7 5L7.53033 4.46967C7.23744 4.17678 6.76256 4.17678 6.46967 4.46967L7 5ZM10.4697 9.53033C10.7626 9.82322 11.2374 9.82322 11.5303 9.53033C11.8232 9.23744 11.8232 8.76256 11.5303 8.46967L10.4697 9.53033ZM7.75 5C7.75 4.58579 7.41421 4.25 7 4.25C6.58579 4.25 6.25 4.58579 6.25 5H7.75ZM6.25 19C6.25 19.4142 6.58579 19.75 7 19.75C7.41421 19.75 7.75 19.4142 7.75 19H6.25ZM3.53033 9.53033L7.53033 5.53033L6.46967 4.46967L2.46967 8.46967L3.53033 9.53033ZM6.46967 5.53033L10.4697 9.53033L11.5303 8.46967L7.53033 4.46967L6.46967 5.53033ZM6.25 5V19H7.75V5H6.25Z"
        fill="#999999"
      />
      <path
        d="M21.5303 15.5303C21.8232 15.2374 21.8232 14.7626 21.5303 14.4697C21.2374 14.1768 20.7626 14.1768 20.4697 14.4697L21.5303 15.5303ZM17 19L16.4697 19.5303C16.7626 19.8232 17.2374 19.8232 17.5303 19.5303L17 19ZM13.5303 14.4697C13.2374 14.1768 12.7626 14.1768 12.4697 14.4697C12.1768 14.7626 12.1768 15.2374 12.4697 15.5303L13.5303 14.4697ZM16.25 19C16.25 19.4142 16.5858 19.75 17 19.75C17.4142 19.75 17.75 19.4142 17.75 19H16.25ZM17.75 5C17.75 4.58579 17.4142 4.25 17 4.25C16.5858 4.25 16.25 4.58579 16.25 5H17.75ZM20.4697 14.4697L16.4697 18.4697L17.5303 19.5303L21.5303 15.5303L20.4697 14.4697ZM17.5303 18.4697L13.5303 14.4697L12.4697 15.5303L16.4697 19.5303L17.5303 18.4697ZM17.75 19V5H16.25V19H17.75Z"
        fill="#999999"
      />
    </svg>
  );
};

export default SortIcon;
